var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['panel', { open: _vm.open }]},[_c('TfButton',{staticClass:"close-btn",attrs:{"type":"primary","icon":"times","size":"icon-no-fill","no-border":""},on:{"click":_vm.closePanel}},[_vm._v("\n    Close Panel\n  ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }